import React from 'react';
import PropTypes from 'prop-types';
var ChipView = function ChipView(_ref) {
  var filterElement = _ref.filterElement,
    onCloseClick = _ref.onCloseClick;
  var closeHandler = function closeHandler() {
    return onCloseClick(filterElement);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "chip",
    role: "button",
    tabIndex: "0",
    onClick: closeHandler,
    onKeyPress: function onKeyPress(e) {
      return e.key === 'Enter' && closeHandler();
    }
  }, filterElement.name);
};
ChipView.propTypes = {
  onCloseClick: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  filterElement: PropTypes.object.isRequired
};
ChipView.defaultProps = {
  onCloseClick: function onCloseClick() {
    return null;
  }
};
export default ChipView;